import { action, observable, runInAction } from 'mobx'
import { ModalViewModel } from '@/infra/ModalViewModel'
import { AsyncPrompt } from '@/infra/AsyncPrompt'
import type { PromptBulkActionOptions } from '@/features/jobs/scoping/OCRScopingJobBulkActionViewModel'

/**
 * Dialog to confirm the submission of the selected scoping jobs.
 */
export class OCRConfirmBulkSubmitDialogViewModel {
  readonly modal = new ModalViewModel()

  private readonly _prompt = new AsyncPrompt<boolean>({
    abort$: this.modal.close$,
  })

  @observable accessor selectedCount = 0

  /**
   * Prompts the user to confirm.
   * @returns Promise resolving to true if confirmed, false if canceled
   */
  async prompt({ selectedCount, signal }: PromptBulkActionOptions) {
    this.modal.close()

    const responsePromise = this._prompt.prompt(signal)
    runInAction(() => {
      this.selectedCount = selectedCount
      this.modal.show()
    })

    const response = await responsePromise
    this.modal.close()
    return response ?? false
  }

  @action.bound
  confirm() {
    this._prompt.respond(true)
  }

  @action.bound
  cancel() {
    this.modal.close()
  }
}
